<!--
  Component: DivPrintableBackground

  This component creates a slottable div container with a colored background
  layer that is printable using the thick border method.

  Notes:
  - bg color is inherited from background-color+border-color set on root
      element from outside
  - Contents of slot are vertically aligned, inline-block by default.
  - Size of root element can be set using CSS from outside, and is then used to
      set size of background layer.
  - In case sizing of BG can't be automatically determined from RootSizeMixin
      (if there is CSS content rules), use bgHeight to set height manually

  Props:
  - bgColor - alternative for manually overriding bg's color directly
  - bgHeight - alternative for manually overriding bg's height directly
-->

<template>
  <div ref="root" class="div-printable-bg">
    <div class="bg" :style="bgStyle"></div>
    <div class="v-outer">
      <div class="v-middle content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Component, { mixins } from 'vue-class-component'
import { RootSizeMixin } from '@/mixin'

@Component({
  props: {
    bgColor: String,
    bgHeight: Number
  }
})
export default class DivPrintableBackground extends mixins(RootSizeMixin) {
  /* Getters */

  get bgStyle () {
    const h = this.bgHeight !== undefined ? this.bgHeight : this.inner.h
    let styleStr = `border-top-width: ${h}px;`
    if (this.bgColor) {
      styleStr += `border-color: ${this.bgColor};`
    }
    return styleStr
  }
}
</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.div-printable-bg {
  position: relative;
  .bg {
    position: absolute;
    width: 100%;
    height: 0px;
    border-top-style: solid;
  }
  /* Inherit background colors so color contrast checker can see content text
    color vs background color, but clear for printing so doesn't show white on
    top of bg */
  .bg, .v-outer, .v-middle {
    border-radius: inherit;
    border-color: inherit;
    background-color: inherit;
  }
  @media print {
    .v-outer, .v-middle {
      background-color: transparent;
    }
  }
  .content > * {
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DivPrintableBackground.vue